<template>
  <div class="group">
    <b-row>
    <b-list-group>
      <b-list-group-item style="text-align: center; font-size: 16px;">
        <strong>Filters(Private)</strong>
      </b-list-group-item>
      <b-list-group-item style="text-align: center; color: #9f5d6b !important; font-size: 16px;">
        <strong>Filter Name</strong>
      </b-list-group-item>
      <b-list-group-item @click="$bvModal.show('view-filter-options')" class="bg-w"><img src="img/filterblue.gif" /> DemandDate</b-list-group-item>
      <b-list-group-item @click="$bvModal.show('view-filter-options')" class="bg-g"><img src="img/filterblue.gif" /> manual</b-list-group-item>
      <b-list-group-item @click="$bvModal.show('view-filter-options')" class="bg-w"><img src="img/filterblue.gif" /> PartialPR</b-list-group-item>
      <b-list-group-item @click="$bvModal.show('view-filter-options')" class="bg-g"><img src="img/filterblue.gif" /> PendPR</b-list-group-item>
      <b-list-group-item @click="$bvModal.show('view-filter-options')" class="bg-w"><img src="img/filterblue.gif" /> RejectedPR</b-list-group-item>
      <b-list-group-item @click="$bvModal.show('view-filter-options')" class="bg-w"><img src="img/filterblue.gif" /> sdfg</b-list-group-item>
      <b-list-group-item @click="$bvModal.show('view-filter-options')" class="bg-w"><img src="img/filterblue.gif" /> UnAuthPr</b-list-group-item>
      <b-list-group-item @click="$bvModal.show('view-filter-options')" class="bg-w"><img src="img/filterblue.gif" /> VendorPR</b-list-group-item>
      <b-list-group-item v-if="filtersArr" @click="$bvModal.show('view-filter-options')" class="bg-w"><img src="img/filterblue.gif" />{{filtersArr[0]}}</b-list-group-item>
    </b-list-group>
  </b-row>

  <b-row>
    <b-list-group>
      <b-list-group-item style="text-align: center; font-size: 16px;">
        <strong>Filters(Public)</strong>
      </b-list-group-item>
      <b-list-group-item style="text-align: center; color: #9f5d6b !important; font-size: 16px;">
        <strong>Filter Name</strong>
      </b-list-group-item>
      <b-list-group-item @click="$bvModal.show('view-filter-options')" class="bg-w"><img src="img/filterblue.gif" /> canceled</b-list-group-item>
      <b-list-group-item @click="$bvModal.show('view-filter-options')" class="bg-g"><img src="img/filterblue.gif" /> CRejYes</b-list-group-item>
      <b-list-group-item @click="$bvModal.show('view-filter-options')" class="bg-w"><img src="img/filterblue.gif" /> MyFil</b-list-group-item>
      <b-list-group-item @click="$bvModal.show('view-filter-options')" class="bg-g"><img src="img/filterblue.gif" /> TestFil</b-list-group-item>
      <b-list-group-item @click="$bvModal.show('view-filter-options')" class="bg-w"><img src="img/filterblue.gif" /> v1</b-list-group-item>
    </b-list-group>
  </b-row>

  </div>


</template>

<script>
export default {
  name: 'FilterNav',
  data() {
      return {
        filtersArr: JSON.parse(window.localStorage.getFiltersArr),
        labelCol: { span: 8 },
        wrapperCol: { span: 16 },
      }
    },
}
</script>

<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.group .list-group{
      margin-left: 25px;
    margin-top: 15px;
    border: 1px solid #333;
    width: 225px;
    padding: 0;
}
.list-group-item{
  background: transparent;
  text-align: left;
      border: 2px solid #fff;
    padding: 0rem;
    font-size: 12px;
    font-weight: 600;
}
.group .list-group-item img{
  border-right: 2px solid #fff;
    padding: 0px 25px 0px 5px;
    background: #bbc7d6;
}
.tableDiv{
  border: 1px solid;
  margin: 20px 0px 15px 5px;
  border-radius: 5px;
  text-align: left;
}
.table-header{
  background: #bdc7d6;
  text-align: left;
  border-bottom: 1px solid;
}
.tableimg{
  padding-left: 10px;
    padding-right: 10px;
    width: 30px;
    margin-top: -4px;
}
.tableheading{
  padding-left: 10px;
      font-size: 14px;
    font-weight: 700;
}
.table-body{
      text-align: center;
    padding: 5px;
}
.table-body select, .table-body input{
  border: 2px inset;
}
.page{
  padding-top: 5px !important;
  padding-left: 15px !important;
   font-weight:500;
    font-size: 12px;
}
.ielogo{
  width: 20px;
  margin-left: 5px;
}
.toolicons{
      position: absolute;
      right: 3px;
    top: -2px;
}
.toolicons .anticon{
      background: #c0c0c0;
    border: 2px outset;
    margin-right: 2px;
    color: #333;
}
.green-glass{
  position: relative;
    display: inline-block;
        padding: 0px 15px;
    border: 0;
    background-color: green;
    background-image: linear-gradient(lightgreen,#66b266,lightgreen);
    text-decoration: none;
    color: #333;
    font-size: 14px;
    font-family: sans-serif;
    font-weight: 700;
    box-shadow: rgb(0 0 0 / 25%) 1.95px 1.95px 2.6px;
    border-radius: 15px;
    margin-right: 5px;
    max-width: 135px;
}
.glass{
position: relative;
    display: inline-block;
    padding: 0px 14px;
    border: 0;
    background-color: green;
    background-image: linear-gradient(#d8e1e9,#c1cfdc,#d8e1e9);
    text-decoration: none;
    color: #333;
    font-size: 15px;
    font-family: sans-serif;
    font-weight: 700;
    box-shadow: rgb(0 0 0 / 25%) 1.95px 1.95px 2.6px;
    border-radius: 15px;
    margin-right: 5px;
    max-width: 135px;
}
select {

  /* styling */
  background-color: white;
  border: thin solid blue;
  border-radius: 4px;
  display: inline-block;
  font: inherit;
  line-height: 1.5em;
  padding: 0em 3.5em 0em 0.5em;

  /* reset */

  margin: 0;      
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  -webkit-appearance: none;
  -moz-appearance: none;
}
select.round {
background-image: linear-gradient( 
45deg, transparent 30%, gray 74%), linear-gradient( 
135deg, gray 68%, transparent 36%), radial-gradient(#c0c0c0 100%, transparent 50%);
    background-position: calc(100% - 12px) calc(1em + -5px), calc(100% - 8px) calc(1em + -5px), calc(100% - 0em) 0em;
    background-size: 5px 5px, 5px 5px, 1.5em 1.5em;
    background-repeat: no-repeat;
    border: 2px inset;
    }
    .view-filter .tableDiv{
  border: 1px solid;
  margin: 20px 0px 15px 5px;
  border-radius: 5px;
  text-align: left;
  min-width: 1200px;
  margin-bottom: 100px;
    padding-bottom: 50px;
}

</style>
